import React from 'react';
import ProductTile from "../../../ProductTile";
import ListGrid from "../../../../ui/ListGrid";
const defaultNumberOfColumns = {
    xsmall: 2,
    small: 2,
    medium: 2,
    large: 3,
    xlarge: 4,
    xxl: 4,
};
const Loader = ({ className, productTileClassName, numberOfColumns = defaultNumberOfColumns, loaderData, }) => {
    const numberOfItems = (loaderData === null || loaderData === void 0 ? void 0 : loaderData.numberOfItems) || 8;
    const showLoaderCta = (loaderData === null || loaderData === void 0 ? void 0 : loaderData.showLoaderCta) || false;
    return (React.createElement(ListGrid, { numberOfColumns: numberOfColumns, className: className }, Array.from({ length: numberOfItems }).map(() => (React.createElement(ProductTile, { isLoading: true, skeletonClassName: productTileClassName, skeletonCtaArea: showLoaderCta, key: `${Math.random()}-ProductTileLoader` })))));
};
export default Loader;
//# sourceMappingURL=Loader.js.map